module.exports = __webpack_public_path__ + "img/30-min.43f59d3e.jpg";